import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "src/shared/shared.module";
import { LineupPage } from "./lineup";
import { ImageCropper } from "./services/image-cropper";
import { LineUpService } from "./services/lineup-service";
import { SortByOrderPipe } from "./directives/sort-by-order/sort-by-order";
import { OnMoveDirective } from "./directives/tshirt-change/on-move";
import { CreatePlayerComponent } from "./components/create-player/create-player";
import { PlayerComponent } from "./components/player/player";
import { PaginatorComponent } from "./components/shared/paginator/paginator";
import { SvgTshirtContainerComponent } from "./components/svg-image-container/svg-tshirt-container";
import { SettingsComponent } from "./components/toolbar/settings/toolbar-settings";
import { ToolbarFieldComponent } from "./components/toolbar/toolbar-field/toolbar-field";
import { ToolbarMainComponent } from "./components/toolbar/toolbar-main/toolbar-main";
import { ToolbarTshirtComponent } from "./components/toolbar/toolbar-tshirt/toolbar-tshirt";
import { IonicModule } from "@ionic/angular";
import { FormsModule } from "@angular/forms";
import { LineTestPage } from "./testpage/test-lineup";
import { CreateTeamComponent } from "./components/create-team/create-team";
const routes: Routes = [
    { path: '', component: LineupPage},
    {path:'settings', component:SettingsComponent}
  ];
@NgModule({
    declarations: [
      LineupPage,
      SortByOrderPipe,
      OnMoveDirective,
      PaginatorComponent,
      SettingsComponent,
      ToolbarFieldComponent,
      ToolbarMainComponent,
      ToolbarTshirtComponent,
      LineTestPage
    ],
    imports: [
        HttpClientModule,
        SharedModule,
        CommonModule,
        RouterModule,
        TranslateModule,
        IonicModule,
        FormsModule,
        RouterModule.forChild(routes),
        PlayerComponent,
        SvgTshirtContainerComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
    ]
  })
  export class LineupModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }